import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import {server} from './constants'

@Injectable()
export class PalletService {
  private httpAddress = server;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  }

  constructor(private http: HttpClient) { }

  getLast10(): Promise<any>{
    // get list of palletids like pallet id limit 10 return list
    return this.http.get(this.httpAddress + 'api/getlast10')
    .toPromise()
    .then(palletlist => palletlist)
    .catch(err => console.log(err));
  }

  getAdvPalletQry2(postWhere): Promise<any>{
    const postData = {select: postWhere};
    // get list of palletids like pallet id limit 10 return list
    return this.http.post(this.httpAddress + 'api/query/getadvpallets', postData)
    .toPromise()
    .then(palletlist => palletlist)
    .catch(err => console.log(err));
  }

  getLikepalletid(palletid): Promise<any>{
    // get list of palletids like pallet id limit 20 return list
    return this.http.get(this.httpAddress + 'api/getid/' + palletid)
    .toPromise()
    .then(palletlist => palletlist)
    .catch(err => console.log(err));
  }

  getSelectedpallet(palletid): Promise<any>{
    // get the selected client then return info also put in localStorage
    return this.http.get(this.httpAddress + 'api/palletvw/' + palletid)
    .toPromise()
    .then(pallet => pallet)
    .catch(err => console.log(err))
  }

  getPictureLinks(palletid): Promise<any>{
    // get list of palletids like pallet id limit 20 return list
    return this.http.get(this.httpAddress + 'api/palletpictures/' + palletid)
    .toPromise()
    .then(palletlinks => palletlinks)
    .catch(err => console.log(err));
  }

  getPalletsLike(like): Promise<any>{
    // get list of palletids like pallet id limit 20 return list
    return this.http.get(this.httpAddress + 'api/descsearch/' + like)
    .toPromise()
    .then(palletlist => palletlist)
    .catch(err => console.log(err));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/pallet.service.ts